module.exports = "<report-generator-page></report-generator-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/reportGenerator.html
// module id = 1827
// module chunks = 0